<template>
  <div>
    <va-card class="mb-4">
      <create @neeFetch="fetchAdditionalProducts" />
    </va-card>
    <additionalProductsTable
      :data="additionalProducts"
      @neeFetch="fetchAdditionalProducts"
    />
  </div>
</template>

<script>
import additionalProductsTable from "../../components/additional-products/table.vue";
import create from "../../components/additional-products/create.vue";
import api from "@/api/axios";
export default {
  name: "AdditionalProducts",
  components: { additionalProductsTable, create },
  data() {
    return {
      additionalProducts: [],
    };
  },
  created() {
    this.fetchAdditionalProducts();
  },
  methods: {
    async fetchAdditionalProducts() {
      try {
        const res = await api.get("/admin/additional-products", {
          params: {
            all: 1,
          },
        });
        this.additionalProducts = res.data.data;
      } catch (error) {
        return error;
      }
    },
  },
};
</script>

<style></style>
